import { IPoll } from "@Interfaces";
import { createSlice, CaseReducer, PayloadAction } from "@reduxjs/toolkit";

interface IPollState extends IPoll {
    voteRegistered: boolean;
}

const initialState: IPollState | null = null;

// ***************************************
// Reducers
// ****************************************

const storeSinglePoll: CaseReducer<any, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state = {
        ...payload,
        comments: {
            count: payload.comments.length,
            list: [],
            isLoading: false,
            isExpanded: false,
            loadMore: false,
        },
        voteRegistered: false,
    };
    return state;
};

const toggleCommentsElementSlice: CaseReducer<any, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state = {
        ...state,
        comments: {
            ...state.comments,
            [payload.element]: !state.comments[payload.element],
        },
    };
    return state;
};

const storePollSliceComments: CaseReducer<any, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state = {
        ...state,
        comments: {
            ...state.comments,
            list: [...state.comments.list, ...payload.commentsList],
        },
    };
    return state;
};

const updatePollSliceVotes: CaseReducer<any, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state = {
        ...state,
        choices: payload.choices,
        total_votes: payload.total_votes,
        vote_id: payload.vote_id,
        voteRegistered: false,
        user_choice: payload.user_choice ?? state?.user_choice,
    };
    return state;
};

const failedVotingAttempt: CaseReducer<any> = (state) => {
    state = {
        ...state,
        voteRegistered: true,
    };
    return state;
};

const storeReportPoll: CaseReducer<any, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state = {
        ...state,
        report: { ...payload },
    };
    return state;
};

const pollSlice = createSlice({
    name: "poll",
    initialState,
    reducers: {
        storeSinglePoll,
        updatePollSliceVotes,
        toggleCommentsElementSlice,
        storePollSliceComments,
        failedVotingAttempt,
        storeReportPoll,
    },
});

export const { name, actions } = pollSlice;

export default pollSlice.reducer;
